<template>
    <PrimeToolbar class="header-bar">
      <template #start>
        <img :src="logoImage" alt="Logo" class="logo">
      </template>
      <template #center>
        <h2 style="margin-top: 0em; font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;font-weight: 600;font-size:xx-large;">Customize Your Boat</h2>
      </template>
      <template #end>
        <PrimeButton class="top-button" label="Back to Site" icon="pi pi-arrow-left" @click="goBack" />
      </template>
    </PrimeToolbar>
    
  
    
    <div class="main-layout">
      
      <div class="boat-image2" :style="{ backgroundImage: `url(${backgroundImage})` }">
      <div class="boat-image">
        <h1 class="image-title" style="font-family: Verdana, Geneva, Tahoma, sans-serif;font-weight: 700;color: white; text-align: center;">TopLine 950</h1>
        <div id="boat-container">
          <img id="boat-base" class="boat-layer" :src="BaseImage" alt="Boat Base">
          <img id="boat-tube" class="boat-layer" :src="tubeImage" alt="Boat Tube">
          <img id="boat-tube" class="boat-layer" :src="tubeDecorationImage" alt="Boat Tube">
          <img id="boat-fender" class="boat-layer" :src="fenderImage" alt="Boat Fender">
          <img id="boat-fiberglass" class="boat-layer" :src="fiberglassImage" alt="Boat Fiberglass">
          <img id="boat-teak" class="boat-layer" :src="teakImage" alt="Boat Teak">
          <img id="boat-Upholestry" class="boat-layer" :src="UpholestryImage" alt="Boat Upholestry">
        </div>
      </div>
    </div>
  
      <div class="customization-options">
        <PrimePanel class="panelHeader" toggleable>
          <template #header>
            <div>Tube: {{ tubeColor }}</div>
          </template>
          <div class="control-group">
            <SelectButton v-model="tubeColor" :options="tubeOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </SelectButton>
          </div>
        </PrimePanel>
        <br>
        <PrimePanel class="panelHeader" toggleable>
          <template #header>
            <div>TubeDecoration: {{ tubedecorationColor }}</div>
          </template>
          <div class="control-group">
            <SelectButton v-model="tubedecorationColor" :options="TubeDecorationOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </SelectButton>
          </div>
        </PrimePanel>
        <br>
  
        <PrimePanel class="panelHeader" toggleable>
          <template #header>
            <div >Fender: {{ fenderColor }}</div>
          </template>
          <div class="control-group">
            <SelectButton v-model="fenderColor" :options="FenderOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </SelectButton>
          </div>
        </PrimePanel>
        <br>
  
        <PrimePanel class="panelHeader" toggleable>
          <template #header>
            <div>Fiberglass: {{ fiberglassColor }}</div>
          </template>
          <div class="control-group">
            <SelectButton v-model="fiberglassColor" :options="FiberGlassOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </SelectButton>
          </div>
        </PrimePanel>
        <br>
  
        <PrimePanel class="panelHeader" toggleable>
          <template #header >
            <div>Deck Floor: {{ teakColor }}</div>
          </template>
          <div  class="control-group ">
            <SelectButton v-model="teakColor" :options="TeakOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </SelectButton>
          </div>
        </PrimePanel>
        <br>
  
        <PrimePanel class="panelHeader" toggleable>
          <template #header>
            <div>Upholestry: {{ UpholestryColor }}</div>
          </template>
          <div class="control-group">
            <PrimeSelectButton v-model="UpholestryColor" :options="UpholestryOptions" optionLabel="label" optionValue="value" dataKey="value" aria-labelledby="custom">
              <template #option="slotProps">
                <div class="tube-color-option">
                <div class="color-circle" :style="{ background: slotProps.option.color }"></div>
                <div class="color-label">{{ slotProps.option.label }}</div>
              </div>
              </template>
            </PrimeSelectButton>
          </div>
        </PrimePanel>
        <br>
        <div class="submit-container">
      <PrimeButton class="submit-button" label="Submit" @click="showDialog = true" />
    </div>
    <!-- <Toast /> -->
    <Dialog v-model:visible="showDialog" header="Enter Your Contact Details" :modal="true" :closable="false" :draggable="false" class="contact-dialog">
        <form @submit.prevent="submitChoices">
          <div class="accessories-list">
              <h3>Select Accessories</h3>
              <!-- <pre>{{ selectedAccessories }}</pre> -->
              <div class="scrollable-content">
              <div class="accessories-grid">
                <div v-for="accessory in accessories" :key="accessory.id" class="p-field-checkbox">
                  <Checkbox v-model="selectedAccessories" :value="accessory.name" />
                  <label>{{ accessory.name }}</label>
                </div>
               </div>
              </div>
            </div> 
          <div class="p-field">
            <label for="name">Name  </label>
            <InputText id="name" v-model="contactDetails.name" required />
          </div>
          <br>
          <div class="p-field">
            <label for="email">Email  </label>
            <InputText id="email" v-model="contactDetails.email" type="email" required />
          </div>
          <br>
          <div class="p-field">
            <label for="phone">Phone  </label>
            <InputText id="phone" v-model="contactDetails.phone" required />
          </div>
          <br>
          <div class="dialog-footer">
            <PrimeButton label="Cancel" @click="showDialog = false" class="p-button-text" />
            <PrimeButton type="submit" label="Submit" />
          </div>
        </form>
      </Dialog>
      </div>
    </div>
  </template>
  
  <script>
  import SelectButton from 'primevue/selectbutton';
  import Dialog from 'primevue/dialog';
  import InputText from 'primevue/inputtext';
  import PrimeButton from 'primevue/button';
  import Checkbox from 'primevue/checkbox';
  // import Toast from 'primevue/toast';
  // import ToastService from 'primevue/toastservice';
  
  export default {
    components: {
      SelectButton,
      Dialog,
      InputText,
      Checkbox,
      PrimeButton,
      // Toast

    },
  //   created() {
  //   this.$toast = ToastService;
  // },
    data() {
      return {
        modelName: 'TopLine 950',
        tubeColor: 'White',
        fenderColor: 'Black',
        fiberglassColor: 'White',
        teakColor: 'Beige',
        UpholestryColor: 'Gray',
        tubedecorationColor: 'Black',
        value: null,
        tubeOptions: [
          { color: '#363737', label: 'Dark Gray', value: 'Dark Gray' },
          { color: '#A5A6A6', label: 'Light Gray', value: 'Light Gray' },
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#FFFFFF', label: 'White', value: 'White' }
        ],
        FenderOptions: [
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#787A7A', label: 'Gray', value: 'Gray' }
        ],
        TubeDecorationOptions: [
          { color: '#363737', label: 'Dark Gray', value: 'Dark Gray' },
          { color: '#A5A6A6', label: 'Light Gray', value: 'Light Gray' },
          { color: '#091837', label: 'Navy Blue', value: 'Navy Blue' },
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#FFFFFF', label: 'White', value: 'White' }
        ],
        FiberGlassOptions: [
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#ffffff', label: 'White', value: 'White' },
          { color: '#787A7A', label: 'Gray', value: 'Gray' }
        ],
        TeakOptions: [
          { color: '#cdb488', label: 'Beige', value: 'Beige' },
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#a85122', label: 'Brown', value: 'Brown' },
          { color: '#939393', label: 'Gray', value: 'Gray' }
        ],
        UpholestryOptions: [
          { color: '#cdb488', label: 'Beige', value: 'Beige' },
          { color: '#000000', label: 'Black', value: 'Black' },
          { color: '#a85122', label: 'Brown', value: 'Brown' },
          { color: '#ffffff', label: 'White', value: 'White' },
          { color: '#939393', label: 'Gray', value: 'Gray' },
          { color: '#9e1615', label: 'Dark Red', value: 'Dark Red' }
        ],
        breadcrumbItems: [
          { label: 'Home', url: '/' },
          { label: 'Customize Boat', url: '/customize' }
        ],
        showDialog: false, // Control the visibility of the dialog
        selectedAccessories: [],
        contactDetails: {
          name: '',
          email: '',
          phone: ''
        },
        accessories: [
        { id: 1, name: ' Boat cover ' },
{ id: 2, name: 'Console /Seat Cover ' },
{ id: 3, name: 'Foam teak Package' },
{ id: 4, name: 'Foam Teak - Full Floor' },
{ id: 5, name: ' SS. Rod holder' },
{ id: 6, name: 'Rollbar -  Aluminum - Hinged - Difference from exsisting rollbar' },
{ id: 7, name: ' Nav. Lights set' },
{ id: 8, name: ' Special Logo up to 50 X 15 Cm' },
{ id: 9, name: ' SS large Ladder  with hand rails - up to two ladders' },
{ id: 10, name: 'Electric Toilet system' },
{ id: 11, name: 'Gas Cooker' },
{ id: 12, name: '12V Fridge' },
{ id: 13, name: 'Toilet Curtain' },
{ id: 14, name: 'Special  Cleats' },
{ id: 15, name: ' 950 TL  two stainless steel bimini tops' },
{ id: 16, name: 'T-top in fiberglass with aluminum legs' },
{ id: 17, name: 'T-top extension with aluminum bars' },
{ id: 18, name: 'Twin Marine Speakers' },
{ id: 19, name: 'Marine music system - Gauge style' },
{ id: 20, name: 'Cup holder - Plastic' },
{ id: 21, name: 'Cup holder - Stainless steel' },
{ id: 22, name: 'Cup holder - Stainless steel - with blue lights' },
{ id: 23, name: 'Electric Anchor System with anchor and chains' },
{ id: 24, name: 'Silvertex leather upgrade' },
{ id: 25, name: 'Electric table / sundbed' },
{ id: 26, name: 'Special luxury steering wheel' },
{ id: 27, name: 'Blue led / Stainless steel logo' },
{ id: 28, name: 'Rollbar lights' },
{ id: 29, name: 'Waste Tank' },
{ id: 30, name: 'Underwater Lights set' },
{ id: 31, name: 'Shore Power socket with electric outlet' },
{ id: 32, name: 'Hydraulic pistone for hatches covers' },
{ id: 33, name: ' Electric outlet socket' },
{ id: 34, name: 'Battery Box' },
{ id: 35, name: ' Deck led lights ( Blue ) Extra lights' },
{ id: 36, name: ' Main battery switch - Single' },
{ id: 37, name: 'Main battery switch - Double' },
{ id: 38, name: 'Hydraulic steering system' },
{ id: 39, name: 'Stainless Steel Ski Pole' },


  
        ],
      };
    },
  
    computed: {
      logoImage() {
        return require('@/assets/images/LOGO-PNG_PNG (1).png');
      },
      BaseImage() {
        return require('@/assets/images/TopLine950/Base/Boat - Base.webp');
      },
      tubeImage() {
        return this.tubeColor
          ? require(`@/assets/images/TopLine950/Tube/Tube - ${this.tubeColor}.webp`)
          : require('@/assets/images/TopLine950/Tube/Tube - White.webp'); // Fallback image
      },
      tubeDecorationImage() {
        return this.tubedecorationColor
          ? require(`@/assets/images/TopLine950/Tube decoration/Tube decoration - ${this.tubedecorationColor}.webp`)
          : require('@/assets/images/TopLine950/Tube decoration/Tube decoration - Black.webp'); // Fallback image
      },
      fenderImage() {
        return this.fenderColor
          ? require(`@/assets/images/TopLine950/Side Fender/Fender - ${this.fenderColor}.webp`)
          : require('@/assets/images/TopLine950/Side Fender/Fender - Gray.webp'); // Fallback image
      },
      fiberglassImage() {
        return this.fiberglassColor
          ? require(`@/assets/images/TopLine950/Fiberglass/Fiberglass - ${this.fiberglassColor}.webp`)
          : require('@/assets/images/TopLine950/Fiberglass/Fiberglass - Gray.webp'); // Fallback image
      },
      teakImage() {
        return this.teakColor
          ? require(`@/assets/images/TopLine950/Deck Floor/deck floor - ${this.teakColor}.webp`)
          : require('@/assets/images/TopLine950/Deck Floor/deck floor - Beige.webp'); // Fallback image
      },
      UpholestryImage() {
        return this.UpholestryColor
          ? require(`@/assets/images/TopLine950/Upholestry/Upholestry - ${this.UpholestryColor}.webp`)
          : require('@/assets/images/TopLine950/Upholestry/Upholestry - Gray.webp'); // Fallback image
      },
      backgroundImage() {
        return require('@/assets/images/background.jpg');
      }
    },
  
    methods: {
      updateImage(part) {
        // Re-trigger computed property update by reassigning the value
        this[`${part}Color`] = this[`${part}Color`];
      },
  
      submitChoices() {
        console.log('Submit button clickeddd');
       // const selectedIds = Object.keys(this.selectedAccessories).filter(key => this.selectedAccessories[key]);
       const selectedAccessoryNames = this.selectedAccessories.map(accessoryName => {
       return this.accessories.find(accessory => accessory.name === accessoryName).name;
       })
  
        const dataToSend = {
          modelName: this.modelName, 
          tubeColor: this.tubeColor,
          fenderColor: this.fenderColor,
          fiberglassColor: this.fiberglassColor,
          teakColor: this.teakColor,
          UpholestryColor: this.UpholestryColor,
          tubedecorationColor:this.tubedecorationColor,
          contact: this.contactDetails,
          accessories: selectedAccessoryNames // Send accessory names instead of IDs
        };
  
        fetch('https://backendcustomizer-production.up.railway.app/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSend)
        })
        .then(response => response.text()) // Read response as text
        .then(text => {
          console.log('Success:', text); // Directly log the text response
          this.showDialog = false; // Close the dialog
          // this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Email sent successfully!', life: 3000 });

        })
        .catch((error) => {
          console.error('Error:', error);
          // this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Failed to send email.', life: 3000 });

        });
      },
  
      openDialog() {
        this.showDialog = true;
      },

      goBack() {
    window.location.href = 'https://www.tigermarine.com/models/950-tl';
  }
  
  
    },
  
  
  };
  </script>
  
  
  <style scoped>
  .header-bar {
    background-color: #2b4b86;
    color: white;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1000;
    height: 75px;
  }
  
  .logo {
    height: 80px;
    margin-top: -1.2em;
    padding-bottom: 1em;
  }
  
  .top-button {
    background-color: #26374f;
    height: 100%; /* Make the button fill the height of the toolbar */
    display: flex;
    align-items: center;
    margin-top: -1.4rem;
    padding: 1.7rem;
    margin-right: -1rem;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  
  }
  
  .panelHeader {
    background-color: #f1f5f7;
    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  
  .breadcrumbs {
    padding: 2rem;
    background-color: #f1f5f7;
    color: white;
    text-align: center;
    font-size: large;
    width: 67%; /* Make the breadcrumbs span the full width */
    margin: 0; /* Remove margin to align with the left edge of the screen */
    box-sizing: border-box; /* Include padding in width calculation */
  }
  
  .breadcrumbs a {
    color: white; /* Ensure links within breadcrumbs are also white */
  }
  
  .breadcrumbs .p-breadcrumb-chevron {
    color: white; /* Change chevron color to white */
  }
  
  .main-layout {
    display: flex;
    flex-direction: row; /* Ensure elements are aligned in a row */
    justify-content: flex-start; /* Align items to the start */
    padding: 0rem;
    margin: 0;
    width: 100%;
    height: calc(100vh - 70px); /* Adjust for the height of the header bar */
    box-sizing: border-box;
    overflow: hidden; /* Prevent overflow */
    position: relative;
  }
  
  .boat-image, .boat-image2 {
    flex: 1;
    height: calc(100% - 0rem); /* Fill the available height, considering padding */
    max-width: 100%;
    object-fit: cover; /* Cover the available area */
    background-size: cover; /* Make sure the image is fully visible */
    background-repeat: no-repeat; /* Avoid repeating the image */
    background-position: center; /* Center the image */
    margin-top: -1rem; /* Remove margin if unnecessary */
  }
  
  .image-title{
    padding: 2rem;
  }
  
  .customization-options {
    background-color: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    overflow-y: auto;
    max-height: 100%; /* Ensure it does not exceed available height */
    width: 100%;
    max-width: 520px;
    margin-top: -1rem; /*Remove top margin to fit the height */
    padding-top: 1rem;
    box-sizing: border-box;
    z-index:auto;
  }
  
  .boat-layer {
    position: absolute; /* Absolute positioning for layers */
    top: 46%; /* Center vertically */
    left: 33%; /* Center horizontally */
    transform: translate(-50%, -50%); /* Offset by half width and height */
    width: 60%; /* Width of the layer */
    height: auto; /* Height adjusts automatically */
    object-fit: cover; /* Ensure images cover the container */
  }
  
  .submit-container {
    position: sticky;
    bottom: 0;
    background-color: #ffffff;
    padding: 1rem;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: flex;
    justify-content: right; /* Center the submit button */
    margin: 0; /* Remove unnecessary margin */
  }
  .submit-button {
    background-color: #2b4b86;
    color: white;
    padding: 0.5rem; /* Add padding for a larger button */
    font-size: 1.2rem; /* Optional: Increase the font size */
    font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  
  }
  .accessories-list {
    margin-bottom: 1em;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;

  }
  
  .accessories-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 5 columns */
    gap: 1em; /* Space between items */
    overflow-y: auto;
  }
  .scrollable-content {
    max-height: 200px; /* Adjust height as needed */
    overflow-y: auto;
    max-width: 600px;
  }
  
  .accessories-grid .p-field-checkbox {
    display: flex;
    align-items: center;
  }
  
  .accessories-grid label {
    margin-left: 0.5em;
  }
  
  .tube-color-option {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .color-circle {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-bottom: 0.5rem;
  }
  
  .color-label {
    text-align: center;
    font-size: 0.9rem;
  }
  
  .circle-style {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 5px;
  }
  
  .circle-style.Black {
    background-color: black;
  }
  
  .circle-style.Dgray {
    background-color: darkgray;
  }
  
  .circle-style.Lgray {
    background-color: lightgray;
  }
  
  .circle-style.NavyBlue {
    background-color: navy;
  }
  
  .circle-style.White {
    background-color: white;
    border: 1px solid black;
  }
  
  .circle-style.Baige {
    background-color: beige;
  }
  
  .circle-style.gray {
    background-color: gray;
  }
  
  .circle-style.Brown {
    background-color: brown;
  }
  
  /* Responsive Styles */
  @media (max-width: 768px) {
    .main-layout {
      flex-direction: column; /* Stack items vertically */
      /* height: auto; Allow height to adjust based on content */
      padding: 0rem; /* Add padding for better spacing on mobile */
      height: 100vh; /* Ensure full height for main layout */
      overflow: hidden; /* Prevent the whole layout from scrolling */


    }

 
    .boat-image, .boat-image2 {
      max-width: 100%;
      height: 350px; /* Increase height for mobile screens */
      position: sticky;

    }
  
    .boat-layer {
      top: 50%; /* Adjust the positioning to fit within the increased height */
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%; /* Ensure the layer spans the full width */
      /* position: sticky; */

    }
  
    .customization-options {
      width: 100%;
      max-width: 100%;
      overflow-y: scroll; /* Allow only customization options to scroll */
      max-height: calc(100vh - 250px); /* Fill remaining height after the boat image */
      margin-top: 1rem;
      padding: 1rem; /* Add padding for better spacing on mobile */
    }
    .submit-container {
      position: static;
      margin-top: 1rem;
    }

    .header-bar {
    flex-direction:column; /* Stack items vertically */
    align-items: center; /* Align items to the start */
    padding: 0.5rem;
    padding-top: 0.6rem;
  }

  .logo {
    height: 60px; /* Reduce logo size */
    margin-top: 0.2rem;
  }

  .top-button {
    margin-top: 0.5rem; /* Add margin between elements */
    padding: 1rem;
    visibility: hidden;
    width: 12px;
  }

  .header-bar h2 {
    font-size: 1.6rem !important;/* Adjust font size for better readability */
    margin-top: 1rem;
    font-weight: 500; /* Make the text weight a bit lighter */
    padding-top: 0.7rem;
    padding-left: 0.1rem;
  }


  .panelHeader {
    padding: 1rem; /* Adjust padding for better spacing */
  }

  .control-group {
    /* overflow:scroll; Hide any overflow content */
    display: flex;
    flex-wrap: wrap; /* Wrap the options */
    justify-content: flex-start; /* Center the options */
    gap: 0.5rem; /* Add space between options */ 
    overflow-x: auto; /* Enable horizontal scrolling */


  }

  .tube-color-option {
    /* flex: 1 1 30%; Adjust width for better layout on smaller screens */
    /* margin-bottom: 1rem; */
    /* text-align: center; Center-align the option labels */


    display: flex;
    justify-content: flex-start; /* Align items to the start */
    align-items: center; /* Vertically center the items */
    overflow-x: auto; /* Enable horizontal scrolling */
    gap: 1rem; /* Add space between the options */
    padding: 0.5rem; /* Add padding for better spacing inside the container */
    }

  .color-circle {
    height: 40px;
    width: 40px;
  }

  .scrollable-content {
    max-height: 150px; /* Adjust height for mobile */
    overflow-y:scroll; /* Add vertical scrolling if necessary */
  }


  .accessories-grid {
    grid-template-columns: repeat(2, 1fr); /* Adjust grid for smaller screens */
    gap: 0.5em; /* Reduce gap for better fit */
  }
  
  .scrollable-content {
    max-height: 150px; /* Adjust height for mobile */
  }




  }

  @media (max-width: 943px) and (min-width: 544px) {
  .main-layout {
    flex-direction: column; /* Stack items vertically */
    height: 100vh;
    overflow: hidden;
  }

  .boat-image, .boat-image2 {
    max-width: 100%;
    height: 450px; /* Set height to avoid it being too large */
    position: relative;
  }

  .boat-layer {
    top: 50%; /* Adjust top positioning to fit better within the boat image */
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75%; /* Decrease width to fit inside the boat image */
    height: auto; /* Keep the aspect ratio */
    object-fit: contain; /* Ensure the boat layer fits within the image */
    z-index: 1;
  }

  .customization-options {
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
    max-height: calc(100vh - 320px); /* Adjust based on the new boat image height */
    margin-top: 1rem;
    padding: 1rem;
    z-index: 2;
  }
}

@media (max-width: 1360px) and (min-width: 944px) {
  .main-layout {
    flex-direction: column; /* Stack items vertically */
    height: 100vh;
    overflow: hidden;
  }

  .boat-image, .boat-image2 {
    max-width: 100%;
    height: 500px; /* Set height to avoid it being too large */
    position: relative;
  }

  .boat-layer {
    top: 50%; /* Adjust top positioning to fit better within the boat image */
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60%; /* Decrease width to fit inside the boat image */
    height: auto; /* Keep the aspect ratio */
    object-fit: contain; /* Ensure the boat layer fits within the image */
    z-index: 1;
  }

  .customization-options {
    width: 100%;
    max-width: 100%;
    overflow-y: auto;
    max-height: calc(100vh - 320px); /* Adjust based on the new boat image height */
    margin-top: 1rem;
    padding: 1rem;
    z-index: 2;
  }
}
  
  
  </style> 
  